// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-ui-UahPrice-styles__root"};